export default __webpack_public_path__ + "static/media/empty-betslip.a74dd185.png";